'use strict';

//const userNameReg = /^[a-zA-Z0-9_-]{3,30}$/;
const userNameReg = /^[a-zA-Z0-9_-]{0,}$/;
function validateLoginName(rule, value, callback) {
    if (!value || userNameReg.test(value)) {
        callback();
    } else  callback(new Error('用户名格式错误'));
}

const userPhoneReg = /^1[345678]\d{9}$/;
function validateUserPhone(rule, value, callback) {
    if (!value || userPhoneReg.test(value)) {
        callback();
    } else callback('手机号格式错误');
}

const userEmailReg=/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.(?:com|cn)$/;
function validateEmail(rule,value,callback) {
    if (!value||userEmailReg.test(value)){
        callback();
    } else callback('邮箱格式错误')
}

function getRules(loginNameRequired = true) {
    return {
        username: [
            {required: loginNameRequired, message: '请输入用户名', trigger: 'change,blur'},
            {validator: validateLoginName, trigger: 'change,blur'}
        ],
        userid: [
            {required: loginNameRequired, message: '请输入用户名', trigger: 'change,blur'},
            {validator: validateLoginName, trigger: 'change,blur'}
        ],
        sex:[
            {required: true, message: '请选择性别', trigger: 'change,blur'},
        ],
        gender:[
            {
                required:true,message:'请选择性别',trigger: 'change,blur'
            }
        ],
        email:[
            {required: true, message: '请输入邮箱', trigger: 'change,blur'},
            {validator: validateEmail,  trigger: 'change,blur'},
        ],
        password:[
            {required: true, message: '请输入密码', trigger: 'change,blur'},
        ],
        roleId: [
            {required: true, message: '请选择用户角色', trigger: 'change,blur'}
        ],
        fullname: [
            {max: 20, message: '姓名最大长度为20位', trigger: 'change,blur'}
        ],
        cname:[
            {max: 20, message: '姓名最大长度为20位', trigger: 'change,blur'}
        ],
        name:[
            {required:true,max: 20, message: '姓名最大长度为20位', trigger: 'change,blur'}
        ],
        mobile : [
            {required: true, message: '请输入手机号', trigger: 'change,blur'},
            {validator: validateUserPhone, trigger: 'change,blur'}
        ],
        status:[
            {required: true, message: '请选择状态', trigger: 'change,blur'},
        ],
        enable:[
            {required: true, message: '请选择状态', trigger: 'change,blur'},
        ]
    };
}

function getDictionaries(){
    return {
    cname:[
        {required:true, message: '中文名不能为空', trigger: 'change,blur'}
    ],
    ename:[
        {required:true,message: '英文名不能为空', trigger: 'change,blur'}
    ]
    }
}
export {
    getRules,getDictionaries
}
